import Button from '@ingka/button';
import ellipsesHorizontalIcon from '@ingka/ssr-icon/paths/ellipses-horizontal';
import { translate } from '@repo/phrase';

interface AssetToggleButtonProps {
    toggleDropdown?: React.DispatchWithoutAction;
    isOpen: boolean;
}

export const AssetToggleDropdownButton = ({ toggleDropdown, isOpen }: AssetToggleButtonProps) => {
    return (
        <Button
            iconOnly
            size="small"
            type="tertiary"
            ssrIcon={ellipsesHorizontalIcon}
            onClick={() => {
                toggleDropdown?.();
            }}
            data-testid="action-toggle-dropdown"
            aria-label={translate('asset_toggle_dropdown')}
            aria-expanded={isOpen}
        />
    );
};
